module.exports = " <h6>¡Tu navegador está obsoleto!</h6> <p>Actualiza tu navegador para ver esta página correctamente. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/es>Actualizar mi navegador ahora</a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Cerrar>&times;</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./outdated-browser/lang/es.html
// module id = 823
// module chunks = 2